<template>
  <div class="search">
    <el-popover placement="bottom" width="420" trigger="manual" v-model="visible" popper-class="site-search-popper">
      <el-input slot="reference" placeholder="Search site" v-model="searchValue" clearable size="small" @input="onInput" @focus="onInput" @clear="clearSearch" @keyup.enter.native="goFirst">
        <i slot="prefix" class="el-input__icon el-icon-search"></i>
      </el-input>

      <div class="search-result-box">
        <div v-for="item in results" :key="`${item.path}__${item.title}`" class="search-result-item" @click="goPage(item)">
          <div class="search-result-top">
            <span class="search-title">{{ item.title }}</span>
            <!-- <span class="search-category">{{ item.category }}</span> -->
          </div>
          <!-- <div class="search-path">{{ item.path }}</div> -->
        </div>

        <div v-if="searchValue && results.length === 0" class="search-empty">
          No results found
        </div>
      </div>
    </el-popover>
  </div>
</template>

<script>
import searchIndex from "@/utils/searchIndex";

export default {
  name: "search",
  data() {
    return {
      searchValue: "",
      visible: false,
      results: []
    };
  },
  watch: {
    $route() {
      this.closeSearch();
    }
  },
  methods: {
    normalize(text) {
      return String(text || "")
        .toLowerCase()
        .replace(/[’']/g, "")
        .replace(/[-_/]/g, " ")
        .trim();
    },

    toSearchTokens(text) {
      return this.normalize(text).match(/[a-z0-9αβ]+/g) || [];
    },

    matchesFromWordStart(text, query) {
      const words = this.toSearchTokens(text);
      const queryWords = this.toSearchTokens(query);

      if (!words.length || !queryWords.length) return false;

      const queryText = queryWords.join(" ");

      return words.some((word, index) => {
        if (queryWords.length === 1) {
          return word.startsWith(queryText);
        }

        return words.slice(index, index + queryWords.length).join(" ").startsWith(queryText);
      });
    },

    getSearchText(item) {
      return this.normalize([
        item.title,
        ...(item.keywords || []),
        ...(item.genes || []),
        item.content || ""
      ].join(" "));
    },

    onInput() {
      const q = this.normalize(this.searchValue);

      if (!q) {
        this.results = [];
        this.visible = false;
        return;
      }

      this.results = searchIndex
        .map(item => {
          const title = this.normalize(item.title);
          const genes = (item.genes || []).map(gene => this.normalize(gene));
          const keywords = this.normalize((item.keywords || []).join(" "));
          const allText = this.getSearchText(item);

          let score = 0;

          if (this.matchesFromWordStart(title, q)) score += 100;
          if (genes.some(gene => gene === q)) score += 120;
          if (genes.some(gene => this.matchesFromWordStart(gene, q))) score += 90;
          if (this.matchesFromWordStart(keywords, q)) score += 70;
          if (this.matchesFromWordStart(allText, q)) score += 30;

          return { ...item, score };
        })
        .filter(item => item.score > 0)
        .sort((a, b) => a.title.localeCompare(b.title));

      this.visible = true;
    },

    closeSearch() {
      this.visible = false;
      this.searchValue = "";
      this.results = [];
    },

    goPage(item) {
      this.closeSearch();

      if (this.$route.path !== item.path) {
        this.$router.push({ path: item.path });
      }
    },

    goFirst() {
      if (this.results.length > 0) {
        this.goPage(this.results[0]);
      }
    },

    clearSearch() {
      this.closeSearch();
    }
  }
};
</script>

<style lang="scss">
.search {
  width: 240px;
  display: flex;
  align-items: center;

  .el-input__inner {
    height: 34px;
    border-radius: 18px;
    padding-left: 34px;
  }

  .el-input__prefix {
    left: 10px;
  }
}

.site-search-popper {
  padding: 8px !important;
}

.search-result-box {
  max-height: 420px;
  overflow-y: auto;
}

.search-result-item {
  padding: 10px 12px;
  cursor: pointer;
  border-radius: 10px;
  white-space: nowrap; /* 防止文本换行 */
  overflow: hidden;
  text-overflow: ellipsis; /* 超出部分用省略号显示 */

  &:hover {
    background: #f5f9ff;
  }
}

.search-result-top {
  display: flex;
  justify-content: space-between;
  gap: 10px;
}

.search-title {
  font-size: 14px;
  font-weight: 700;
  color: #0f172a;
}

.search-category {
  font-size: 12px;
  color: #2563eb;
  white-space: nowrap;
}

.search-path {
  margin-top: 4px;
  font-size: 12px;
  color: #64748b;
}

.search-empty {
  padding: 14px;
  text-align: center;
  color: #94a3b8;
  font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// src/views/search/index.vue